import React from "react";
import Back from "assets/images/svg/back_blue.svg";
import { Modal } from "react-bootstrap";
import { Button, DateField, Form } from "components/form";
import { useTranslation } from "react-i18next";

interface CustomDateDialogProps {
  show: boolean;
  onHide: () => void;
  onChange: (date: { from: string; to: string }) => void;
}

const CustomDateDialog = ({ show, onHide, onChange }: CustomDateDialogProps) => {
  const { t } = useTranslation("common");

  return (
    <>
      <Modal show={show} onHide={onHide} centered className="all-modal changeNumber">
        <Modal.Body>
          <div className="header">
            <img src={Back} alt="back" onClick={onHide} />
            <h1>{t("sort.customDate") as string}</h1>
          </div>
          <Form onSubmit={onChange} onChange={console.log} defaultValues={{ from: "", to: "" }}>
            {({watch }) => {
              return (
                <>
                  <div className="row">
                    <div className="col-md-12">
                      <DateField
                        id="from"
                        label={t("sort.from")}
                        rules={{
                          required: "errors:required"
                        }}
                      />
                    </div>
                    <div className="col-md-12">
                      <DateField
                        id="to"
                        label={t("sort.to")}
                        rules={{
                          required: "errors:required"
                        }}
                        min={watch('from')}
                      />
                      {/*<InputField*/}
                      {/*  type="date"*/}
                      {/*  id="to"*/}
                      {/*  label={t("to")}*/}
                      {/*  rules={{*/}
                      {/*    required: "errors:required"*/}
                      {/*  }}*/}
                      {/*/>*/}
                    </div>

                    <div className="col-12">
                      <Button className="btn-blue">{t("sort.apply") as string}</Button>
                    </div>
                  </div>
                </>
              );
            }}
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CustomDateDialog;
